import React, {useEffect, useState} from 'react'
import {Button, Header} from 'semantic-ui-react'
import JsonView, {ReactJsonViewProps} from 'react-json-view'
// import {
//     JsonView,
//     Props as ReactJsonProps,
//     darkStyles,
//     collapseAllNested,
// } from 'react-json-view-lite';
// import 'react-json-view-lite/dist/index.css';
import './style.css'

export interface IJsonViewerProps extends Omit<Omit<ReactJsonViewProps, 'src'>, 'style' | 'data'> {
  data: object | any[] | undefined
  header?: string
  style?: React.CSSProperties
  jsonStyle?: React.CSSProperties
  expanded?: boolean
  canClose?: boolean
}

export function JsonViewer(props: IJsonViewerProps) {
  const {data, header, style, jsonStyle, expanded, canClose, ...rest} = {
    expanded: false,
    canClose: true,
    ...props,
  } as IJsonViewerProps

  const [viewJson, setViewJson] = useState(expanded)

  useEffect(() => {
    setViewJson(expanded)
  }, [expanded])

  return (
    <div
      className='json-viewer'
      style={style}
    >
      {header ?
        <Header content={header} />
      : null}
      {viewJson ?
        <>
          <JsonView
            src={data || {}}
            theme='paraiso'
            iconStyle='square'
            enableClipboard={true}
            displayDataTypes={true}
            displayObjectSize={false}
            collapsed={false}
            collapseStringsAfterLength={50}
            // src={clientInventoryConfig}
            style={{
              // minHeight: '100%',
              maxHeight: '500px',
              overflowY: 'auto',
              textAlign: 'left',
              ...jsonStyle,
            }}
            {...rest}
          />
          {/* <JsonView
                style={darkStyles}
                data={data || {}}
                shouldExpandNode={collapseAllNested}
                {...rest}
            /> */}
          {canClose ?
            <div
              style={{
                position: 'absolute',
                top: 0,
                right: 0,
              }}
            >
              <Button
                compact
                size='tiny'
                icon='close'
                color='red'
                onClick={() => setViewJson(false)}
              />
            </div>
          : null}
        </>
      : <Button
          compact
          inverted
          size='tiny'
          icon='dna'
          content='View JSON'
          onClick={() => setViewJson(true)}
        />
      }
    </div>
  )
}
